<template>
  <div v-if="home.length == 0">
    <div class="my-4 text-center">
      <Skeleton width="50%" height="30px" class="inline-block" />
    </div>
    <div class="grid">
      <div class="col-12 md:col-6">
        <Skeleton shape="circle" size="60px" class="inline-block va-middle" />
        <div class="inline-block va-middle ml-2" style="width: 70%">
          <Skeleton width="90%" height="30px" />
          <Skeleton width="70%" height="10px" class="mt-1" />
        </div>
        <Skeleton width="100%" height="200px" class="mt-2" />
        <div class="grid mt-1">
          <div class="col-6">
            <Skeleton width="75%" height="30px" />
          </div>
          <div class="col-6 text-right">
            <Skeleton width="75%" height="30px" class="inline-block" />
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <Skeleton shape="circle" size="60px" class="inline-block va-middle" />
        <div class="inline-block va-middle ml-2" style="width: 70%">
          <Skeleton width="90%" height="30px" />
          <Skeleton width="70%" height="10px" class="mt-1" />
        </div>
        <Skeleton width="100%" height="200px" class="mt-2" />
        <div class="grid mt-1">
          <div class="col-6">
            <Skeleton width="75%" height="30px" />
          </div>
          <div class="col-6 text-right">
            <Skeleton width="75%" height="30px" class="inline-block" />
          </div>
        </div>
      </div>
    </div>

    <div class="my-4 text-center">
      <Skeleton width="50%" height="30px" class="inline-block" />
    </div>

    <div class="grid">
      <div class="col-6 md:col-3">
        <Skeleton shape="circle" size="60px" class="inline-block va-middle" />
        <div class="inline-block va-middle ml-2" style="width: 70%">
          <Skeleton width="90%" height="30px" />
          <Skeleton width="70%" height="10px" class="mt-1" />
        </div>
        <Skeleton width="100%" height="150px" class="mt-2" />
        <div class="grid mt-1">
          <div class="col-6">
            <Skeleton width="75%" height="30px" />
          </div>
          <div class="col-6 text-right">
            <Skeleton width="75%" height="30px" class="inline-block" />
          </div>
        </div>
      </div>
      <div class="col-6 md:col-3">
        <Skeleton shape="circle" size="60px" class="inline-block va-middle" />
        <div class="inline-block va-middle ml-2" style="width: 70%">
          <Skeleton width="90%" height="30px" />
          <Skeleton width="70%" height="10px" class="mt-1" />
        </div>
        <Skeleton width="100%" height="150px" class="mt-2" />
        <div class="grid mt-1">
          <div class="col-6">
            <Skeleton width="75%" height="30px" />
          </div>
          <div class="col-6 text-right">
            <Skeleton width="75%" height="30px" class="inline-block" />
          </div>
        </div>
      </div>
      <div class="col-6 md:col-3">
        <Skeleton shape="circle" size="60px" class="inline-block va-middle" />
        <div class="inline-block va-middle ml-2" style="width: 70%">
          <Skeleton width="90%" height="30px" />
          <Skeleton width="70%" height="10px" class="mt-1" />
        </div>
        <Skeleton width="100%" height="150px" class="mt-2" />
        <div class="grid mt-1">
          <div class="col-6">
            <Skeleton width="75%" height="30px" />
          </div>
          <div class="col-6 text-right">
            <Skeleton width="75%" height="30px" class="inline-block" />
          </div>
        </div>
      </div>
      <div class="col-6 md:col-3">
        <Skeleton shape="circle" size="60px" class="inline-block va-middle" />
        <div class="inline-block va-middle ml-2" style="width: 70%">
          <Skeleton width="90%" height="30px" />
          <Skeleton width="70%" height="10px" class="mt-1" />
        </div>
        <Skeleton width="100%" height="150px" class="mt-2" />
        <div class="grid mt-1">
          <div class="col-6">
            <Skeleton width="75%" height="30px" />
          </div>
          <div class="col-6 text-right">
            <Skeleton width="75%" height="30px" class="inline-block" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="sessoes-home" v-else>

    <div id="categorias" class="fixed right-0 left-0 px-1 md:px-5 py-2" v-show="sessoes_visivel">

      <div v-if="subsessoes.length" class="subsessoes py-2" :style="subsessoes_style">

        <Button v-if="subsessoes_sessao != null" label="Ir à categoria" class="p-button-text my-1 bt-sessao-subsessao"
          style="display: block; width: 100%" @click="irDiretoParaSessao(subsessoes_sessao)" />

        <Button v-for="s of subsessoes" :key="s.label" :label="s.label" class="p-button-text my-1 bt-sessao-subsessao"
          style="display: block; width: 100%" @click="irDiretoParaSubSessao(s)" />

      </div>

      <div class="p-0">
        <Carousel :value="sessoes" :numVisible="5" :numScroll="4" :responsiveOptions="breakpointsCategorias"
          indicatorsContentClass="hidden">
          <template #item="{ data }">
            <div class="sessao text-center" :id="'sess-' + data.id">
              <a :class="sessao_visivel == data.id
                ? 'sessao-visivel block w-full bt-sessao-subsessao'
                : 'block w-full bt-sessao-subsessao'
                " @click="
                  irParaSessao($event, data);
                " style="font-size: 1.2rem;">{{ data.label }}</a>
            </div>
          </template>
        </Carousel>
      </div>
    </div>

    <Banner v-if="empresa.capaWeb" />

    <div v-for="h of home" :key="h" :id="h.id">
      <h3 class="sessao-titulo text-2xl text-center" v-if="typeof h.nome == 'string' && h.nome != ''">{{ h.nome }} </h3>

      <div v-if="h.comportamento == 'MultiplosPorLinha'">
        <div class="grid mt-3">
          <div :class="'col-' +
            12 / h.qtdColunasMobile +
            ' md:col-' +
            12 / h.qtdColunasDesktop
            " v-for="i of h.itens" :key="i.id">
            <component :is="h.componente" :value="i"></component>
          </div>
        </div>
      </div>

      <div v-else-if="h.comportamento == 'Carrocel'">
        <Carrocel :itens="h.itens" :breakpoints="breakpointsCarrocel[h.componente]" :componente="h.componente"
          class="mt-3" />
      </div>
    </div>

    <Button label="V carregar mais produtos... V" @click="carregaHomeParcial" class="w-full mt-4"
      style="background-color: var(--primaryBackgroundColor); border-color: var(--primaryBackgroundColor); font-size: 1.6em"
      v-show="carregandoHome == false && homeCompleta == false" />

    <ProgressBar class="mt-4" style="height: 10px" v-show="carregandoHome" mode="indeterminate" />

  </div>
  
</template>

<script>
import moment from "moment-timezone";
export default {
  data() {
    return {
      home: [],
      empresa: { nomeEmpresa: "", cnpj: "" },
      sessoes: [],

      subsessoes: [],
      subsessoes_style: "",
      subsessoes_sessao: null,
      subsessoes_ativa: "",

      sessao_visivel: "",
      sessoes_visivel: true,
      isMobile: document.body.classList.contains("is-touch"),
      scrollAnterior: 0,
      breakpointsCarrocel: {
        ProdutoResumido: [
          {
            largura: 4000,
            visivel: 4,
          },
          {
            largura: 900,
            visivel: 3,
          },
          {
            largura: 500,
            visivel: 1,
          },
        ],
        Status: [
          {
            largura: 4000,
            visivel: 6,
          },
          {
            largura: 900,
            visivel: 6,
          },
          {
            largura: 500,
            visivel: 3,
          },
        ],
      },

      breakpointsCategorias: [
        {
          breakpoint: "1024px",
          numVisible: 4,
          numScroll: 3,
        },
        {
          breakpoint: "700px",
          numVisible: 3,
          numScroll: 2,
        },
        {
          breakpoint: "600px",
          numVisible: 2,
          numScroll: 2,
        },
        {
          breakpoint: "480px",
          numVisible: 2,
          numScroll: 2,
        },
      ],
      displayStoris: true,
      carregandoHome: false,
      homeCompleta: false,
      isPageVisible: true,
      dataEntrada: moment().tz("America/Sao_Paulo").toDate(),
      usuario: null,
      isAtualizou: false,

     
    };
  },
  mounted() {
    //console.log("iniciou")
    this.dataEntrada = moment().tz("America/Sao_Paulo").toDate();
    this.isAtualizou = false;
    document.body.classList.add("with-category-bar");
    this.scrollAnterior = window.scrollY;
    window.addEventListener("click", this.onClick);
    document.addEventListener("visibilitychange", this.verificarVisibilidade);
  },
  beforeUnmount() {
    document.body.classList.remove("with-category-bar");
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("visibilitychange", this.verificarVisibilidade);
    this.atualizar_comportamento();

  },
  watch: {
    "$root.empresa": {
      handler: function (empresa) {
        // const self = this;

        if (empresa != null) {
          this.empresa = empresa;
          this.carregaHomeInicial();
          // this.carregaHomeParcial();
          this.$root.carregaCarrinho();
        }
      },
      deep: true,
      immediate: true,
    },
    "$root.user": {
      handler: function (user) {
        if (user != null) {
          this.usuario = user;
        } else {
          this.usuario = { id: this.$fpid, nome: "Usuário Anônimo" };
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {

    // OK
    posicionaSubsessao(referencia) {

      referencia = referencia.getBoundingClientRect();
      const oItens = document.querySelector("#categorias .p-carousel-content").getBoundingClientRect();
      const oContainer = document.querySelector("#categorias").getBoundingClientRect();

      const hContainer = oContainer.height;
      const hItens = oItens.height;
      const wItem = referencia.width;
      const lItem = referencia.left;

      const top = hContainer - ((hContainer - hItens) / 2) - 1;

      this.subsessoes_style = "width: " + wItem + "px; top: " + top + "px; left: " + lItem + "px";

    },

    // OK
    onScroll() {

      const sessoes = this.$utils.getStdObject(this.sessoes).reverse();
      //const ultima_sessao = sessoes[this.home.length - 1]
      const sessao_visivel = sessoes.find(
        (e) => typeof e.scrollY != "undefined" && e.scrollY < window.scrollY
      );

      if (typeof sessao_visivel != "undefined") {
        this.sessao_visivel = sessao_visivel.id;
      }

      if (this.isMobile) {
        if (this.scrollAnterior > window.scrollY) {
          this.scrollAnterior = window.scrollY;
          this.sessoes_visivel = true;
        } else if (this.scrollAnterior < window.scrollY) {
          this.scrollAnterior = window.scrollY;
          this.sessoes_visivel = false;
        }
      }

      ///////////////////////////////////////////////////////////

      const obj_fim_pagina = document.getElementById("sessoes-home");
      const desconto_fim_pagina = window.outerHeight;
      const y_fim_pagina = obj_fim_pagina.offsetTop + obj_fim_pagina.offsetHeight - desconto_fim_pagina;

      if (window.scrollY > y_fim_pagina) { // FIM DA PÁGINA

        this.carregaHomeParcial();

      }

    },

    // OK
    onClick(e) {
      if (!e.target.classList.contains('bt-sessao-subsessao')) {
        if (this.subsessoes.length > 0) {
          this.subsessoes_sessao = null;
          this.subsessoes = [];
        }
      }
    },

    // OK
    irParaSessao(event, sessao) {

      const parent = event.target.closest(".sessao");

      if (this.subsessoes_ativa == parent.id) {
        this.subsessoes_ativa = "";
        this.subsessoes_sessao = null;
        this.subsessoes = [];
        return
      }

      if (typeof sessao.subsessoes == "undefined" || sessao.subsessoes.length == 0) {
        this.subsessoes_ativa = "";
        this.subsessoes_sessao = null;
        this.subsessoes = [];
        this.irDiretoParaSessao(sessao);
        return;
      }

      this.posicionaSubsessao(parent);
      this.subsessoes_ativa = parent.id;
      this.subsessoes = sessao.subsessoes;
      this.subsessoes_sessao = sessao;

    },

    // OK
    irDiretoParaSessao(sessao) {

      this.subsessoes_sessao = null;
      this.subsessoes = [];

      if (typeof sessao.scrollY == "undefined") {
        this.$router.push({ name: 'busca', params: { text: sessao.label } });
        return;
      }
      this.$scrollTo("#" + sessao.id, 500, { offset: -120 });

    },

    // OK
    irDiretoParaSubSessao(subsessao) {

      this.$router.push({ name: 'busca', params: { text: subsessao.idBusca } });

      this.subsessoes_sessao = null;
      this.subsessoes = [];

    },

    // OK
    atualizarSessao(idh) {

      const self = this;

      const homeElement = self.home[idh];

      let wait = setInterval(() => {
        if (document.getElementById(homeElement.id) != null) {
          clearInterval(wait);

          const idx = self.sessoes.findIndex((e) => e.id == homeElement.id);
          const el = document.getElementById(homeElement.id);
          if (typeof self.sessoes[idx] != "undefined" && el != null)
            self.sessoes[idx].scrollY = el.offsetTop;

        }
      }, 500);

    },

    // OK
    async carregaHomeParcial() {

      if (this.homeCompleta || this.carregandoHome)
        return;

      this.carregandoHome = true;

      await new Promise(resolve => setTimeout(resolve, 500));

      const idh = this.home.length;

      if (typeof this.$root.conteudo[idh] != "undefined") {

        this.home.push(this.$root.conteudo[idh]);

        this.atualizarSessao(idh);

      } else {
        this.homeCompleta = true;
      }

      this.carregandoHome = false;

    },

    // OK
    async carregaHomeInicial() {

      this.carregandoHome = true;

      await this.$root.carregaConteudo();

      if (this.$root.conteudo.length > 0) {

        for (const c of this.$root.conteudo) {
          if (c.componente != "Status") {

            let subsessoes;
            if (typeof c.nome != "string" || c.nome == "") {
              subsessoes = this.sessoes.find((obj) => obj.idPai == c.idPai).subsessoes;
            } else {
              subsessoes = [];
            }

            for (const p of c.itens) {
              const id = "subsessao-" + c.idPai + "-" + this.$utils.slugify(p.subCategoria);
              if (typeof subsessoes.find((obj) => obj.id == id) == "undefined") {
                subsessoes.push({
                  id: id,
                  idBusca: c.nome_interno + " - " + p.subCategoria,
                  label: p.subCategoria
                });
              }
            }

            if (typeof c.nome == "string" && c.nome != "") {
              this.sessoes.push({
                id: c.id,
                idPai: c.idPai,
                label: c.nome,
                subsessoes: subsessoes
              });
            } else {
              this.sessoes.find((obj) => obj.idPai == c.idPai).subsessoes = subsessoes;
            }
          }
        }

        // Inicia Monitoramento de Scroll
        window.addEventListener("scroll", this.onScroll);

        if (this.$root.conteudo[0].componente == "Status") {
          this.home.push(this.$root.conteudo[0]);
          this.home.push(this.$root.conteudo[1]);
          this.atualizarSessao(1);
        } else {
          this.home.push(this.$root.conteudo[0]);
          this.atualizarSessao(0);
        }

      } else {
        alert("Página inicial indisponível!");
      }

      this.carregandoHome = false;

    },

    verificarVisibilidade() {
      this.isPageVisible = !document.hidden;
      if (this.isPageVisible) {
        console.log("A página está em primeiro plano.");
      } else {
        console.log("A página está em segundo plano.");
        if (!this.isAtualizou) {

          this.atualizar_comportamento();
        }

      }
    },
    async atualizar_comportamento() {

      if (this.isAtualizou) return

      this.isAtualizou = true;

      let body = {
        "origem": "web",
        "acaoSeguinte": "",
        "pedido": {},
        "query": {},
        "categoria": "Visualizar E-commerce",
        "usuario": this.usuario,
        "dispositivo": "Web",
        "produto": {},
        "resultadoQuery": [],
        "lat": 0,
        "lng": 0,
        "tela": "Home",
        "tempo": this.$utils.calcularDiferencaEmMinutos(moment().tz("America/Sao_Paulo").toDate(), this.dataEntrada),
        "dataEntrada": this.dataEntrada,
        "dataSaida": moment().tz("America/Sao_Paulo").toDate()
      }
      await this.$apiv3.post("/comportamentos", body);

    }

  }
};
</script>

<style lang="scss" scoped>
.fundo-branco {
  background-color: white;
}

.sessao-titulo {
  color: var(--secondaryColor, $secondaryColor);
}

#categorias {
  z-index: 998;
  top: 55px;
  background: var(--primaryBackgroundColor, $primaryBackgroundColor);
}

:deep(#categorias .p-carousel .p-carousel-content .p-carousel-prev),
:deep(#categorias .p-carousel .p-carousel-content .p-carousel-next) {
  margin: 0;
  padding: 0;
  color: white;
  height: 1.7rem;
  width: 1.7rem;
}

:deep(#categorias .p-carousel .p-carousel-content .p-carousel-prev:enabled:hover),
:deep(#categorias .p-carousel .p-carousel-content .p-carousel-next:enabled:hover) {
  color: var(--secondaryColor, $secondaryColor);
  background: var(--secondaryBackgroundColor, $secondaryBackgroundColor);
}

:deep(#categorias .bt-sessao-subsessao) {
  padding: 0.2rem 0.3rem;
  cursor: pointer;
}

:deep(#categorias .bt-sessao-subsessao) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: white;
}

:deep(#categorias .sessao-visivel) {
  color: var(--secondaryColor, $secondaryColor) !important;
  background: var(--secondaryBackgroundColor, $secondaryBackgroundColor);
}

.subsessoes {
  position: absolute;
  z-index: 9999;
  background: var(--primaryBackgroundColor, $primaryBackgroundColor);
}


</style>